var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14V8h-4V4H8V1H0v6h3v1H2v1h4V8H5V7h3V5h3v3H8v6h3v1h-1v1h4v-1h-1v-1h3zM7 6H1V2h6v4zm2 7V9h6v4H9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortIcon);
export default __webpack_public_path__ + "static/media/port-icon.75ae369a9a2679e3d51c0de1825eeebf.svg";
export { ForwardRef as ReactComponent };